// import React from 'react';
// import ReactDOM from 'react-dom';

// import { CssBaseline } from '@material-ui/core';
// import { MuiThemeProvider } from '@material-ui/core/styles';
 import 'bootstrap/dist/css/bootstrap.min.css';

// import App from './pages/App';
// import JoinRoom from './pages/joinRoom';
// import ThankYou from './pages/thankYou';
// import AppStateProvider, { useAppState } from './state';
// import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
// import { ConnectOptions } from 'twilio-video';
// import ErrorDialog from './components/ErrorDialog/ErrorDialog';
// import PrivateRoute from './components/PrivateRoute/PrivateRoute';
// import theme from './theme';
// import './types';
// import { VideoProvider } from './components/VideoProvider';

// // See: https://media.twiliocdn.com/sdk/js/video/releases/2.0.0/docs/global.html#ConnectOptions
// // for available connection options.
// const connectionOptions: ConnectOptions = {
//   bandwidthProfile: {
//     video: {
//       mode: 'collaboration',
//       renderDimensions: {
//         high: { height: 1080, width: 1920 },
//         standard: { height: 90, width: 160 },
//         low: { height: 90, width: 160 },
//       },
//     },
//   },
//   dominantSpeaker: true,
//   maxAudioBitrate: 12000,
//   networkQuality: { local: 1, remote: 1 },
//   preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
// };

// const VideoApp = () => {
//   const { error, setError } = useAppState();

//   return (
//     <VideoProvider options={connectionOptions} onError={setError}>
//       <ErrorDialog dismissError={() => {
//         window.location.replace('/thank-you');
//         return setError(null)
//         }} error={error} />
//       <App />
//     </VideoProvider>
//   );
// };

// ReactDOM.render(
//   <MuiThemeProvider theme={theme}>
//     <CssBaseline />
//     <Router>
//       <AppStateProvider>
//         <Switch>
//           {/* <PrivateRoute exact path="/">
//             <VideoApp />
//           </PrivateRoute> */}
//           <PrivateRoute exact path="/room">
//             <VideoApp />
//           </PrivateRoute>
//           <PrivateRoute exact path="/">
//             <JoinRoom />
//           </PrivateRoute>
//           <PrivateRoute exact path="/thank-you">
//             <ThankYou />
//           </PrivateRoute>
//           {/* <Route path="/login">
//             <LoginPage />
//           </Route>
//           <Redirect to="/" /> */}
//         </Switch>
//       </AppStateProvider>
//     </Router>
//   </MuiThemeProvider>,
//   document.getElementById('root')
// );
 

import React from 'react';
import ReactDOM from 'react-dom';
import BaseApp from './baseApp';
// import * as serviceWorker from './serviceWorker';
import 'antd/dist/antd.css';

ReactDOM.render(<BaseApp />, document.getElementById('root'));